import { faBadgeCheck as faBadgeCheckRegular } from '@fortawesome/pro-regular-svg-icons';
import { faBadgeCheck as faBadgeCheckSolid } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HoverIconButton } from 'components/button/HoverIconButton';
import { ReactNode } from 'react';
import styled from 'styled-components';

export function ApprovedSensorBadge() {
    return <FontAwesomeIcon icon={faBadgeCheckSolid} title="Approved" />;
}

const ApprovedTextWrapper = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 0.2em; // '&thinsp;'
`;

export function ApprovedText({
    text,
    approved = true,
}: {
    text: ReactNode;
    approved?: boolean;
}): JSX.Element {
    return (
        <ApprovedTextWrapper>
            {text}
            {approved ? <ApprovedSensorBadge /> : <></>}
        </ApprovedTextWrapper>
    );
}

export type ApproveActionButtonProps = {
    onClick: () => void;
};
export function ApproveActionButton({ onClick }: ApproveActionButtonProps): JSX.Element {
    return (
        <HoverIconButton
            title="Approve"
            icon={faBadgeCheckRegular}
            hoverIcon={faBadgeCheckSolid}
            color="var(--icon-action-active)"
            hoverColor="var(--icon-action-hover)"
            size="14"
            onClick={onClick}
        />
    );
}
